import { composeParsers } from 'style-utils/core/createExtractCssFromProps/utils/composeParsers';
import { WithMarginProps, withMargin } from './withMarginProps';
import { WithPaddingProps, withPadding } from './withPaddingProps';

export type WithSpacingProps = WithMarginProps & WithPaddingProps;

export const withSpacing = composeParsers(withMargin, withPadding);
